import React from 'react';
import { useSelector } from 'react-redux';
import LineGraphMain from './graphInMainPopup/lineGraph/LineGraphMain';
import CircleGraphMain from './graphInMainPopup/circleGraph/CircleGraphMain';
import useGraphLogData from 'utils/customHook/useGraphLogData';
import { LegendContainer } from './MainPopup.css';

import { graphOrder, utmMap, reverseRangeMap } from 'utils/code';

const MainPopup = (props) => {
  const criterion = useSelector((store) => store.criterion)[props.engTitle]; // 각 탐지파트별 관리기준 설정
  const logData = useGraphLogData(props.title, props.moduleIdx);
  const lineData = logData === null ? [] : [...logData].reverse();

  if (!logData) {
    return null;
  }

  return (
    <div>
      <LineGraphMain data={lineData} criterion={criterion} {...props} />
      <CircleGraphMain criterion={criterion} {...props} />
      <LegendContainer>
        {graphOrder[props.moduleScn].map((key) => {
          return (
            <div className="contentBox" key={key}>
              <div className="title">법적관리기준</div>
              <div>
                {criterion[key]
                  .filter((x) => x.standType === 'criterion')
                  .map((data) => {
                    return `${data.standVal}${utmMap[key] === '' ? '' : `(${utmMap[key]})`}${reverseRangeMap[data.standRange]}`;
                  })
                  .join(' ')}
              </div>
            </div>
          );
        })}
      </LegendContainer>
    </div>
  );
};

export default React.memo(MainPopup);
